// extracted by mini-css-extract-plugin
module.exports = {"edit_lot":"EditLot_edit_lot__3qazQ","edit_form":"EditLot_edit_form__2vlTt","save_edit_btn":"EditLot_save_edit_btn__3ZBqH","edit_history_btn":"EditLot_edit_history_btn__3oBZE"};